import { useState } from "react";
import { layDiemDoGanNhat } from "../core/perf";

// Tên bước dễ đọc cho Le (giữ tên gốc trong bảng do_thoi_gian để so số).
const TEN: Record<string, string> = {
  tong_toi_luc_dung_duoc: "Mở → dùng được",
  khoi_phuc_cache: "Đọc cache máy",
  rpc_bootstrap: "Tải cả bộ (tổng)",
  rpc_bootstrap_may_chu: "  ↳ máy chủ",
  rpc_bootstrap_mang: "  ↳ mạng",
  rpc_delta: "Tải phần đổi (tổng)",
  rpc_delta_may_chu: "  ↳ máy chủ",
  rpc_delta_mang: "  ↳ mạng",
  delta_vao_cache: "Dòng đổi vá vào cache",
  engine: "Tính buổi (engine)",
  ve: "Vẽ bảng",
  loc: "Lọc",
  sort: "Sắp xếp",
  tai_app_user: "Kiểm tài khoản",
  mo_form: "Mở form lớp",
  luu_cam_nhan: "Lưu lớp — cảm nhận",
  luu_xac_nhan: "Lưu lớp — server xác nhận",
  luu_may_chu: "  ↳ máy chủ",
  doi_trang_thai_cam_nhan: "Đổi trạng thái — cảm nhận",
  doi_trang_thai_xac_nhan: "Đổi trạng thái — server xác nhận",
  chuyen_man: "Chuyển màn",
  mo_bo_tong: "Mở bộ kế hoạch (tổng)",
  mo_bo_may_chu: "  ↳ máy chủ",
  mo_bo_mang: "  ↳ mạng",
  mo_bo_ve: "  ↳ vẽ",
  rpc_hv_bo: "Tải HV của bộ (tổng)",
  rpc_hv_bo_may_chu: "  ↳ máy chủ",
  rpc_hv_bo_mang: "  ↳ mạng",
  tai_file_doc: "Tải file HV — đọc xlsx",
  tai_file_ghi: "Tải file HV — ghi (server)",
  tai_file_ghi_may_chu: "  ↳ máy chủ",
  ghep_cam_nhan: "Kéo thả ghép — cảm nhận",
  ghep_xac_nhan: "Kéo thả ghép — server xác nhận",
  ghep_may_chu: "  ↳ máy chủ",
  sua_tai_cho_cam_nhan: "Sửa tại chỗ — cảm nhận",
  sua_tai_cho_xac_nhan: "Sửa tại chỗ — server xác nhận",
  sua_tai_cho_may_chu: "  ↳ máy chủ",
  them_kh_cam_nhan: "Thêm lớp KH — cảm nhận",
  them_kh_xac_nhan: "Thêm lớp KH — server xác nhận",
  them_kh_may_chu: "  ↳ máy chủ",
  xoa_kh_cam_nhan: "Xoá lớp KH — cảm nhận",
  xoa_kh_xac_nhan: "Xoá lớp KH — server xác nhận",
  xoa_kh_may_chu: "  ↳ máy chủ",
  ttfb: "TTFB",
  fcp: "FCP",
  lcp: "LCP",
};
const kb = (b?: number) => (b ? (b / 1024).toFixed(0) + " KB" : "");

// Nút "⏱" — hiện bảng đo lần mở gần nhất (ARCHITECTURE §6.2). Chỉ đọc RAM, không gọi mạng.
export function PerfPanel() {
  const [mo, setMo] = useState(false);
  const [, setLan] = useState(0); // bấm "↻" để đọc lại số đo mới nhất

  return (
    <div style={{ position: "fixed", right: 12, bottom: 12, zIndex: 1000 }}>
      <button
        onClick={() => setMo((v) => !v)}
        title="Xem số đo hiệu năng lần gần nhất"
        style={{ borderRadius: "50%", width: 40, height: 40, border: "1px solid #ccc", background: "#fff", cursor: "pointer" }}
      >
        ⏱
      </button>
      {mo && (
        <div
          className="perf-panel"
          style={{
            position: "absolute", right: 0, bottom: 48, width: 470, maxHeight: 460, overflow: "auto", background: "#fff",
            border: "1px solid #ccc", borderRadius: 8, padding: 8, fontSize: 12, boxShadow: "0 6px 18px rgba(0,0,0,0.18)",
          }}
        >
          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
            <b>Số đo gần nhất (mới nhất ở trên)</b>
            <button onClick={() => setLan((n) => n + 1)} style={{ cursor: "pointer" }}>↻</button>
          </div>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th align="left">Màn</th>
                <th align="left">Bước</th>
                <th align="right">ms</th>
                <th align="right">dòng</th>
                <th align="right">byte</th>
                <th align="center">cache</th>
              </tr>
            </thead>
            <tbody>
              {layDiemDoGanNhat()
                .slice(-40)
                .reverse()
                .map((d, i) => (
                  <tr key={i} style={{ borderTop: "1px solid #eee" }}>
                    <td>{d.man_hinh}</td>
                    <td style={{ whiteSpace: "pre" }} title={d.buoc}>{TEN[d.buoc] ?? d.buoc}</td>
                    <td align="right">{d.ms.toFixed(0)}</td>
                    <td align="right">{d.so_dong ?? ""}</td>
                    <td align="right">{kb(d.byte)}</td>
                    <td align="center">{d.cache_hit === undefined ? "" : d.cache_hit ? "có" : "không"}</td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
